// extracted by mini-css-extract-plugin
export var bodySections = "_by-8";
export var gray = "_by-7";
export var green = "_by-4";
export var iconContainer = "_by-9";
export var iconWidgetContainer = "_by-1";
export var phoneIcon = "_by-2";
export var red = "_by-5";
export var statusDot = "_by-3";
export var widgetContainer = "_by-0";
export var yellow = "_by-6";